<template>
  <div class="coupon-code-container">
    <div v-if="label" class="text-caption text-grey q-mb-xs">{{ label }}</div>
    <div class="code-display-box row no-wrap items-center" :class="compact ? 'compact' : ''">
      <div class="code-text" :class="{'text-truncate': code.length > 15}">{{ code }}</div>
      <q-btn
        flat
        round
        :size="buttonSize"
        color="primary"
        icon="content_copy"
        class="copy-btn"
        @click="copyCode"
        :loading="copying"
        :disable="copying"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref } from 'vue';
import { useQuasar } from 'quasar';

const props = defineProps({
  code: {
    type: String,
    required: true
  },
  label: {
    type: String,
    default: 'Coupon Code:'
  },
  compact: {
    type: Boolean,
    default: false
  },
  buttonSize: {
    type: String,
    default: 'sm'
  }
});

const emit = defineEmits(['code-copied']);
const $q = useQuasar();
const copying = ref(false);

function copyCode() {
  copying.value = true;
  navigator.clipboard.writeText(props.code).then(() => {
    $q.notify({ message: 'Code copied to clipboard!', color: 'positive', icon: 'content_copy', position: 'top', timeout: 2000 });
    emit('code-copied');
  }).catch(() => {
    $q.notify({ message: 'Failed to copy code', color: 'negative', position: 'top', timeout: 2000 });
  }).finally(() => {
    copying.value = false;
  });
}
</script>

<style lang="scss" scoped>
.code-display-box {
  background-color: #fff;
  border: 1px dashed #1976d2;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 8px;
  
  &.compact {
    padding: 4px 8px;
  }
  
  .code-text {
    font-family: monospace;
    font-size: 18px;
    flex-grow: 1;
    text-align: center;
    letter-spacing: 1px;
    font-weight: 500;
  }
  
  .copy-btn {
    margin-left: 8px;
  }
}

.body--dark {
  .code-display-box {
    background-color: #1d1d1d;
    border-color: #5c9fe6;
  }
}
</style>
